import React from 'react';
import { Link } from 'react-router-dom';
import AnnouncementBar from '../components/AnnouncementBar.jsx';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';
export default function MomsCircle() {
  return <div className="min-h-screen bg-white" data-name="Mom's Group Page">
      {/* Announcement Bar */}
      <div className="fixed top-0 left-0 right-0 z-[60]">
        <AnnouncementBar />
      </div>
      
      {/* Transparent Navigation */}
      <div className="absolute top-0 left-0 right-0 z-50">
        <Navigation transparent={true} />
      </div>

      {/* Hero Section with Background Image */}
      <section className="relative pt-48 pb-24 px-6 bg-cover bg-center" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1593296123312-d6555e88dc75?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwzfHxtb20lMjBhbmQlMjBiYWJ5JTIwY29ubmVjdGlvbnxlbnwwfHx8fDE3NjQ2MjY5NDZ8MA&ixlib=rb-4.1.0&q=80&w=1080)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-name="Hero Section">
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40"></div>
        
        <div className="relative max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Mom's Empowerment Circle</h1>
          <p className="text-2xl md:text-3xl mb-4 font-light"></p>
          <p className="text-xl md:text-2xl mb-8 font-semibold">for those wanting to break generational cycles<br />Wednesdays • 12:00 PM PST</p>
          <a target="_blank" rel="noopener noreferrer" className="inline-block bg-sage-400 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-sage-500 transition-colors" data-tracking-id="link-1019971432e9e3b4" href="https://calendly.com/yphilipos/mom-s-empowerment-circle">
            First Session Free. No Strings Attached. Babies Welcome
          </a>
        </div>
        
        {/* Image Attribution */}
        <span data-editor-skip="true" className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
          <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
          <span className="hidden drop-shadow-md group-hover/attribution:block">
            Image on{' '}
            <a href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
            color: '#fff',
            textDecoration: 'none'
          }} data-tracking-id="link-5b29eea7bfbc28ea">
              Unsplash
            </a>{' '}
            by{' '}
            <a href="https://unsplash.com/@nate_dumlao?utm_source=makerdevi&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
            color: '#fff',
            textDecoration: 'none'
          }} data-tracking-id="link-7a2baae137a29d25">
              Nathan Dumlao
            </a>
          </span>
        </span>
      </section>

      {/* Sanctuary Description */}
      <section className="py-16 px-6 bg-sage-50" data-name="Sanctuary Description">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-2xl text-gray-800 leading-relaxed mb-8">A weekly sanctuary for mom's... because every mom deserves a village.</p>
          <p className="text-lg text-gray-700 leading-relaxed">for those wanting a safe space to land, reconnect with self, and others</p>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 px-6 bg-white" data-name="How It Works">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">for any mom any where</h2>

          <div className="space-y-12">
            {/* Your First Session Is Completely Free */}
            <div className="bg-sage-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-4 text-sage-700">Your First Session Is Free</h3>
              <p className="text-lg text-gray-700 leading-relaxed">{"Come feel the space, meet the community, and see how deeply supported you fee, with no pressure."}</p>
            </div>

            {/* Drop-In Model */}
            <div className="bg-warmcream-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-4 text-warmcream-700">Drop-In Model (No Long-Term Commitment)</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">You can drop in any week. Flexible, mum-friendly, and easy.</p>
              <p className="text-xl font-semibold text-gray-900 mb-2"></p>
              <p className="text-gray-700"></p>
            </div>


          </div>
        </div>
      </section>

      {/* What You'll Experience Each Week */}
      <section className="py-20 px-6 bg-sage-50" data-name="What You'll Experience">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">this is what you get</h2>

          <div className="space-y-10">
            {/* Nervous-System Reset */}
            <div>
              <h3 className="text-2xl font-bold mb-3 text-sage-700">
                Nervous-System Reset
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">A soft landing space to help you arrive fully into your body.</p>
              <p className="text-lg text-gray-700 leading-relaxed mt-2"></p>
            </div>

            {/* Weekly Healing Tool */}
            <div>
              <h3 className="text-2xl font-bold mb-3 text-sage-700">Healing Tools</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                One topic is covered each week based on the needs of the women who show up, including:
              </p>
              <div className="grid md:grid-cols-3 gap-4">
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>burnout</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>mum guilt</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>stress & overwhelm</span>
                  </li>
                </ul>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>nervous system regulation</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>identity loss</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>anxious thoughts</span>
                  </li>
                </ul>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>boundaries</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>people-pleasing</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-sage-600 mr-2">•</span>
                    <span>a mother's emotional load</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Practice */}
            <div>
              <h3 className="text-2xl font-bold mb-3 text-sage-700">Community</h3>
              <p className="text-lg text-gray-700 leading-relaxed">Partner holding of space, reflection prompts, and journal guidance. No advice giving. Only soft supportive sisterhood. #BehenCode</p>
            </div>
          </div>
        </div>
      </section>

      {/* Who This Is For */}
      <section className="py-20 px-6 bg-white" data-name="Who This Is For">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-gray-900"></h2>

          <div className="text-center">
            <p className="text-xl text-gray-800 leading-relaxed mb-2">
              this can be your space. this could be your village
            </p>
            <p className="text-lg text-gray-700 leading-relaxed"></p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section data-name="Final CTA" className="py-16 px-6 bg-[#f3f8ee]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900"></h2>
          <a target="_blank" rel="noopener noreferrer" className="inline-block bg-sage-400 text-white px-10 py-4 rounded-full text-lg leading-7 font-semibold hover:bg-sage-500 transition-colors ease-in-out duration" data-tracking-id="link-6e26609f8c8e137e" href="https://calendly.com/yphilipos/mom-s-empowerment-circle">
            First Session Free. No Strings Attached. Babies Welcome
          </a>
        </div>
      </section>

      <Footer />
    </div>;
}